"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SideMenuTitle = exports.SideMenuAction = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@react-spectrum/text");
var _Menu = require("@react/react-spectrum/Menu");
var _List = require("@react/react-spectrum/List");
var _AppConstants = _interopRequireDefault(require("../../../../../constants/AppConstants"));
var _PropTypeCustomAction = require("../../prop-type-custom-action/PropTypeCustomAction");
var _ServiceRegistry = _interopRequireDefault(require("../../../../../util/ServiceRegistry"));
var _ComponentRegistry = _interopRequireDefault(require("../../../../../util/ComponentRegistry"));
var _LocalizationUtils = _interopRequireDefault(require("../../../../../util/LocalizationUtils"));
require("!style-loader!css-loader!./SideMenu.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

class SideMenu extends _react.Component {
  renderPureReactActions() {
    const {
      actions
    } = this.props;
    return actions.map(({
      id,
      action: Action,
      showOnlyInTopBar
    }) => !showOnlyInTopBar && /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, {
      key: id,
      className: "sdk-SideMenu-sideMenuActionItem",
      tabIndex: -1
    }, /*#__PURE__*/_react.default.createElement(Action, null)));
  }
  renderOurActions() {
    const {
      actions
    } = this.props;
    return actions.map(action => {
      if (action.type === "title") {
        return /*#__PURE__*/_react.default.createElement(SideMenuTitle, {
          key: action.id,
          action: action
        });
      }
      return /*#__PURE__*/_react.default.createElement(SideMenuAction, {
        key: action.id,
        action: action
      });
    });
  }
  renderCustomActions() {
    const {
      actions
    } = this.props;
    if (actions[0].label) {
      return this.renderOurActions();
    }
    return this.renderPureReactActions();
  }
  render() {
    const {
      actions
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_List.List, {
      className: "sdk-SideMenu",
      role: "menu"
    }, actions && actions.length > 0 && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, this.renderCustomActions(), _ServiceRegistry.default.getService("AppStore").configStore.hasAdobeMenuActions() && !_ServiceRegistry.default.getService("AppStore").enableModernViewer && /*#__PURE__*/_react.default.createElement("hr", {
      className: "sdk-SideMenu-menuDivider"
    })), _ComponentRegistry.default.getComponent("AdobeMenuActions", this.props));
  }
}
SideMenu.propTypes = {
  actions: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_PropTypeCustomAction.propTypeReactCustomAction, _PropTypeCustomAction.propTypeJsonCustomAction]))
};
SideMenu.defaultProps = {
  actions: []
};
function sideMenuActionItemClassName() {
  const appStore = _ServiceRegistry.default.getService("AppStore");
  let sideMenuActionItemClass = "sdk-SideMenu-sideMenuActionItem";
  if (appStore.enableModernViewer) {
    sideMenuActionItemClass += " sdk-SideMenu-sideMenuActionItemModernViewer";
  }
  return sideMenuActionItemClass;
}
const SideMenuAction = ({
  action
}) => /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, {
  className: sideMenuActionItemClassName(),
  onClick: () => {
    try {
      const workflow = "SideMenuAction";
      const subcategory = _AppConstants.default.SUBCATEGORY_USE;
      const type = _AppConstants.default.SUBCATEGORY_TYPE_CLICK;
      const event = {
        workflow,
        subcategory,
        type,
        subtype: action.id
      };
      _ServiceRegistry.default.getService("AnalyticsProviderService").logEvent(event);
      action.onClick();
    } catch (error) {
      _ServiceRegistry.default.getService("LoggingService").error("SideMenuAction", `The ${action.label} action in the side bar threw an error`, error);
    }
  },
  selected: action.selected,
  label: action.label,
  icon: action.Icon
});
exports.SideMenuAction = SideMenuAction;
SideMenuAction.propTypes = {
  action: _PropTypeCustomAction.propTypeJsonCustomAction.isRequired
};
const SideMenuTitle = ({
  action: {
    label
  }
}) => /*#__PURE__*/_react.default.createElement(_text.Heading, {
  size: 5
}, label);
exports.SideMenuTitle = SideMenuTitle;
SideMenuTitle.propTypes = {
  action: _PropTypeCustomAction.propTypeJsonCustomAction.isRequired
};
var _default = exports.default = (0, _LocalizationUtils.default)(SideMenu);